import React, { useEffect, useState, createElement } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { BookOpenIcon, HeadphonesIcon, UtensilsCrossedIcon, ZapIcon, HeartIcon, MoonIcon, LeafIcon, ClockIcon, CheckIcon, StarIcon, ShieldIcon, ArrowRightIcon, FlameIcon, BrainIcon, ActivityIcon } from 'lucide-react';
const PURCHASE_URL = 'https://manosquegeneran.com/cart/48375336665315:1';
// ── Meta Pixel ──────────────────────────────────────────────────────
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: unknown;
  }
}
function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return;
  const fbq: any = (...args: unknown[]) => {
    if ((fbq as any).callMethod) (fbq as any).callMethod(...args);else (fbq as any).queue.push(args);
  };
  window.fbq = fbq;
  window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', '1651839656232002');
}
// ───────────────────────────────────────────────────────────────────
export function SalesPage() {
  const [showStickyBar, setShowStickyBar] = useState(false);
  useEffect(() => {
    // Fire PageView on mount
    initMetaPixel();
    window.fbq('track', 'PageView');
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setShowStickyBar(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen w-full" style={{
    backgroundColor: '#FDF8F3',
    color: '#1A1A1A'
  }} data-id="element-3">
      {/* ━━━ STICKY TOP BAR ━━━ */}
      <div className="sticky top-0 z-50 w-full py-3 px-4 flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3 text-center" style={{
      backgroundColor: '#1A1A1A'
    }} data-id="element-4">
        <span className="text-white text-xs sm:text-sm font-medium" data-id="element-5">
          <span style={{
          color: '#D4A843'
        }} data-id="element-6">
            ⚡
          </span>{' '}
          <strong data-id="element-7">FLASH SALE:</strong> Get the 3-Step Reset for the price of a
          lunch.
        </span>
        <span className="text-white text-xs sm:text-sm flex items-center gap-2" data-id="element-8">
          <span style={{
          color: '#9A8A7E'
        }} data-id="element-9">
            Offer ends in:
          </span>
          <CountdownTimer data-id="element-10" />
        </span>
      </div>

      {/* ━━━ HERO ━━━ */}
      <section className="w-full px-4 pt-10 pb-8 md:pt-20 md:pb-14 text-center max-w-3xl mx-auto" data-id="element-11">
        <p className="text-xs font-bold uppercase tracking-widest mb-5" style={{
        color: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        letterSpacing: '0.2em'
      }} data-id="element-12">
          The Cortisol Cure
        </p>

        <h1 className="text-3xl md:text-5xl font-bold leading-tight mb-5" style={{
        fontFamily: 'Georgia, serif',
        color: '#1A1A1A'
      }} data-id="element-13">
          Stop "Pushing Through" The Burnout.{' '}
          <span style={{
          color: '#4A7C59'
        }} data-id="element-14">
            Reset Your Nervous System
          </span>{' '}
          and Melt "Cortisol Belly" in{' '}
          <span style={{
          color: '#C85A2A'
        }} data-id="element-15">
            10 Mins/Day.
          </span>
        </h1>

        <p className="text-base md:text-lg mt-4 mb-8 max-w-xl mx-auto" style={{
        color: '#6B5B4E',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        lineHeight: '1.7'
      }} data-id="element-16">
          The Somatic Protocol for Busy Moms. No HIIT. No Diets. No Stress.{' '}
          <strong style={{
          color: '#1A1A1A'
        }} data-id="element-17">
            Just Science-Backed Calm.
          </strong>
        </p>

        <CTAButton large data-id="element-18" />

        <p className="text-xs mt-4" style={{
        color: '#9A8A7E',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-19">
          One-Time Payment · Instant Digital Access · All Sales Final
        </p>
      </section>

      <ThinDivider data-id="element-20" />

      {/* ━━━ HOOK ━━━ */}
      <section className="w-full px-4 py-8 md:py-12 max-w-3xl mx-auto" data-id="element-21">
        <div className="rounded-2xl p-6 md:p-8" style={{
        backgroundColor: '#FFFFFF',
        border: '1px solid #E8DDD0'
      }} data-id="element-22">
          <BookOpenIcon className="w-7 h-7 mb-4" style={{
          color: '#4A7C59'
        }} data-id="element-23" />
          <h2 className="text-xl md:text-2xl font-bold mb-4" style={{
          fontFamily: 'Georgia, serif',
          color: '#1A1A1A'
        }} data-id="element-24">
            You're Doing Everything Right... and Still Feeling Worse.
          </h2>
          <p className="text-sm md:text-base leading-relaxed mb-4" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#3D3D3D'
        }} data-id="element-25">
            By 3:00 PM, you're running on fumes. You look in the mirror and
            don't recognize the woman looking back — inflamed, exhausted, and
            constantly on edge. You've tried the fasted coffee, the hour-long
            Pilates classes, and intermittent fasting... but nothing works.
          </p>
          <p className="text-sm md:text-base leading-relaxed" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#3D3D3D'
        }} data-id="element-26">
            In fact, the harder you push, the more that stubborn belly fat
            clings to your body.
          </p>
        </div>

        <div className="rounded-2xl p-6 md:p-8 mt-4 border-l-4" style={{
        backgroundColor: '#F5F0E8',
        borderLeftColor: '#4A7C59'
      }} data-id="element-27">
          <p className="text-xs font-bold uppercase tracking-widest mb-3" style={{
          color: '#4A7C59',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }} data-id="element-28">
            The truth the fitness industry hides from you
          </p>
          <p className="text-base md:text-lg font-medium leading-relaxed" style={{
          fontFamily: 'Georgia, serif',
          color: '#1A1A1A'
        }} data-id="element-29">
            You don't have a willpower problem. You have a biological survival
            problem. Your body thinks it's under constant attack — and its
            response is to store fat and drain your energy.
          </p>
        </div>
      </section>

      <ThinDivider data-id="element-30" />

      {/* ━━━ PAIN AGITATION ━━━ */}
      <section className="w-full px-4 py-8 md:py-12 max-w-3xl mx-auto" data-id="element-31">
        <p className="text-xs font-bold uppercase tracking-widest mb-3 text-center" style={{
        color: '#C85A2A',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-32">
          The Cortisol Trap
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" style={{
        fontFamily: 'Georgia, serif',
        color: '#1A1A1A'
      }} data-id="element-33">
          Does This Sound Familiar?
        </h2>

        <div className="space-y-3 mb-8" data-id="element-34">
          <PainCard icon={<MoonIcon className="w-5 h-5 flex-shrink-0" style={{
          color: '#4A7C59'
        }} data-id="element-36" />} text={'You wake up exhausted, even after "8 hours" of sleep.'} data-id="element-35" />
          <PainCard icon={<ZapIcon className="w-5 h-5 flex-shrink-0" style={{
          color: '#4A7C59'
        }} data-id="element-38" />} text={'You live in constant "fight or flight," snapping at every noise the kids make.'} data-id="element-37" />
          <PainCard icon={<ActivityIcon className="w-5 h-5 flex-shrink-0" style={{
          color: '#4A7C59'
        }} data-id="element-40" />} text="Your stomach is bloated, hard, and has a mind of its own — the infamous Cortisol Belly." data-id="element-39" />
          <PainCard icon={<FlameIcon className="w-5 h-5 flex-shrink-0" style={{
          color: '#4A7C59'
        }} data-id="element-42" />} text="You feel like you're failing at work and at home because you simply don't have the energy." data-id="element-41" />
        </div>

        <div className="rounded-2xl p-5 md:p-7 text-center" style={{
        backgroundColor: '#1A1A1A',
        color: '#FDF8F3'
      }} data-id="element-43">
          <p className="text-base md:text-lg font-bold mb-2" style={{
          fontFamily: 'Georgia, serif'
        }} data-id="element-44">
            You are trapped in the Cortisol Death Loop.
          </p>
          <p className="text-xs md:text-sm leading-relaxed" style={{
          color: '#C8B8A8',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }} data-id="element-45">
            Intense exercise → cortisol spike → inflammation → depletion → sugar
            cravings → repeat.
          </p>
          <p className="text-sm font-bold mt-3" style={{
          color: '#D4A843',
          fontFamily: 'Georgia, serif'
        }} data-id="element-46">
            It's time to break the loop.
          </p>
        </div>
      </section>

      <ThinDivider data-id="element-47" />

      {/* ━━━ REVELATION ━━━ */}
      <section className="w-full px-4 py-8 md:py-12 max-w-3xl mx-auto text-center" data-id="element-48">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{
        color: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        letterSpacing: '0.2em'
      }} data-id="element-49">
          Introducing
        </p>
        <h2 className="text-2xl md:text-4xl font-bold mb-3" style={{
        fontFamily: 'Georgia, serif',
        color: '#1A1A1A'
      }} data-id="element-50">
          THE CORTISOL CURE
        </h2>
        <p className="text-sm md:text-base mb-8 font-semibold" style={{
        color: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-51">
          A Nervous System Regulation Protocol — Not Just Another Workout Plan
        </p>

        <div className="rounded-2xl p-6 md:p-8 mb-6 text-left" style={{
        backgroundColor: '#FFFFFF',
        border: '1px solid #E8DDD0'
      }} data-id="element-52">
          <BrainIcon className="w-7 h-7 mb-4" style={{
          color: '#4A7C59'
        }} data-id="element-53" />
          <p className="text-sm md:text-base leading-relaxed mb-4" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#3D3D3D'
        }} data-id="element-54">
            We discovered that by using{' '}
            <strong data-id="element-55">low-impact somatic movements</strong> — shaking, tapping,
            and psoas release — we can "trick" your brain into switching from{' '}
            <strong data-id="element-56">Survival Mode</strong> to <strong data-id="element-57">Repair Mode</strong>.
          </p>
          <p className="text-sm md:text-base leading-relaxed" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#3D3D3D'
        }} data-id="element-58">
            When your nervous system finally feels safe, your metabolism
            ignites. The belly fat begins to mobilize because your body no
            longer needs to "protect" you with stress-fat.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-2 md:gap-3 mb-8" data-id="element-59">
          <FeaturePill icon={<ClockIcon className="w-4 h-4" data-id="element-61" />} text="10 Min/Day" data-id="element-60" />
          <FeaturePill icon={<LeafIcon className="w-4 h-4" data-id="element-63" />} text="Low Impact" data-id="element-62" />
          <FeaturePill icon={<HeartIcon className="w-4 h-4" data-id="element-65" />} text="In Your PJs" data-id="element-64" />
        </div>

        <CTAButton large data-id="element-66" />
      </section>

      <ThinDivider data-id="element-67" />

      {/* ━━━ SOCIAL PROOF ━━━ */}
      <section className="w-full px-4 py-8 md:py-12 max-w-3xl mx-auto" data-id="element-68">
        <p className="text-xs font-bold uppercase tracking-widest mb-3 text-center" style={{
        color: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-69">
          Real Women. Real Results.
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-7" style={{
        fontFamily: 'Georgia, serif',
        color: '#1A1A1A'
      }} data-id="element-70">
          What Happens When You Stop Fighting Your Body
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-71">
          <TestimonialCard quote="I lost 4 inches off my waist in 21 days without stepping foot in a gym. I finally have energy to play with my kids after work. This literally saved my sanity." name="Jennifer S." detail="39 · Texas" stars={5} data-id="element-72" />
          <TestimonialCard quote="I thought I needed more caffeine. Turns out I just needed to regulate my vagus nerve. The 10-minute somatic flows are now non-negotiable in my morning." name="Michelle R." detail="42 · Florida" stars={5} data-id="element-73" />
        </div>
      </section>

      <ThinDivider data-id="element-74" />

      {/* ━━━ VALUE STACK / OFFER ━━━ */}
      <section id="offer" className="w-full px-4 py-8 md:py-12 max-w-3xl mx-auto" data-id="element-75">
        <p className="text-xs font-bold uppercase tracking-widest mb-3 text-center" style={{
        color: '#C85A2A',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-76">
          Everything You Get Today
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" style={{
        fontFamily: 'Georgia, serif',
        color: '#1A1A1A'
      }} data-id="element-77">
          The Cortisol Cure Bundle
        </h2>

        <div className="rounded-2xl overflow-hidden mb-6" style={{
        border: '1.5px solid #4A7C59',
        boxShadow: '0 4px 24px rgba(74,124,89,0.12)'
      }} data-id="element-78">
          {/* Core product */}
          <div className="p-5 md:p-6" style={{
          backgroundColor: '#4A7C59'
        }} data-id="element-79">
            <div className="flex items-start justify-between gap-3" data-id="element-80">
              <div className="flex items-start gap-3" data-id="element-81">
                <BookOpenIcon className="w-6 h-6 text-white flex-shrink-0 mt-0.5" data-id="element-82" />
                <div data-id="element-83">
                  <p className="text-xs font-bold uppercase tracking-widest text-green-200 mb-1" data-id="element-84">
                    Core Program
                  </p>
                  <h3 className="text-base md:text-lg font-bold text-white" style={{
                  fontFamily: 'Georgia, serif'
                }} data-id="element-85">
                    The Cortisol Cure Core Ebook
                  </h3>
                  <p className="text-green-100 text-xs mt-0.5" style={{
                  fontFamily: 'system-ui, -apple-system, sans-serif'
                }} data-id="element-86">
                    The step-by-step 21-day somatic system
                  </p>
                </div>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-87">
                <p className="text-green-200 text-xs line-through" data-id="element-88">$197</p>
                <p className="text-white font-bold text-sm" data-id="element-89">Included</p>
              </div>
            </div>
          </div>

          {/* Bonuses */}
          <div style={{
          backgroundColor: '#FFFFFF'
        }} data-id="element-90">
            <BundleRow icon={<UtensilsCrossedIcon className="w-5 h-5 flex-shrink-0" style={{
            color: '#4A7C59'
          }} data-id="element-92" />} label="Bonus #1" title='7-Day Anti-Inflammatory "No-Cook" Meal Plan' value="$97" data-id="element-91" />
            <div style={{
            height: '1px',
            backgroundColor: '#E8DDD0'
          }} data-id="element-93" />
            <BundleRow icon={<HeadphonesIcon className="w-5 h-5 flex-shrink-0" style={{
            color: '#4A7C59'
          }} data-id="element-95" />} label="Bonus #2" title='5-Minute "Emergency Calm" Audio Series' value="$67" data-id="element-94" />
          </div>

          {/* Pricing */}
          <div className="p-5 md:p-6" style={{
          backgroundColor: '#F5F0E8'
        }} data-id="element-96">
            <div className="flex items-center justify-between mb-3" data-id="element-97">
              <span className="text-sm" style={{
              color: '#6B5B4E',
              fontFamily: 'system-ui, -apple-system, sans-serif'
            }} data-id="element-98">
                Total Value:
              </span>
              <span className="text-lg font-bold line-through" style={{
              color: '#9A8A7E',
              fontFamily: 'Georgia, serif'
            }} data-id="element-99">
                $361
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-100">
              <span className="text-base font-bold" style={{
              color: '#1A1A1A',
              fontFamily: 'system-ui, -apple-system, sans-serif'
            }} data-id="element-101">
                Today's Special Price:
              </span>
              <div className="text-right" data-id="element-102">
                <span className="text-4xl font-bold" style={{
                color: '#C85A2A',
                fontFamily: 'Georgia, serif'
              }} data-id="element-103">
                  $14.27
                </span>
                <span className="text-xs ml-1" style={{
                color: '#6B5B4E'
              }} data-id="element-104">
                  USD
                </span>
              </div>
            </div>
            <p className="text-xs text-center mt-2" style={{
            color: '#9A8A7E',
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }} data-id="element-105">
              One-time payment · No subscriptions · All sales final
            </p>
          </div>
        </div>

        <PurchasePageButton data-id="element-106" />
        <p className="text-xs text-center mt-3" style={{
        color: '#9A8A7E',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-107">
          Secure checkout · Instant digital access
        </p>
      </section>

      <ThinDivider data-id="element-108" />

      {/* ━━━ TRANSFORMATION PROMISE (replaces guarantee) ━━━ */}
      <section className="w-full px-4 py-8 md:py-12 max-w-3xl mx-auto" data-id="element-109">
        <div className="rounded-2xl p-6 md:p-8 text-center" style={{
        backgroundColor: '#FFFFFF',
        border: '1.5px solid #D4A843'
      }} data-id="element-110">
          <ShieldIcon className="w-8 h-8 mx-auto mb-4" style={{
          color: '#D4A843'
        }} data-id="element-111" />
          <p className="text-xs font-bold uppercase tracking-widest mb-3" style={{
          color: '#D4A843',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }} data-id="element-112">
            Our Commitment
          </p>
          <h2 className="text-xl md:text-2xl font-bold mb-4" style={{
          fontFamily: 'Georgia, serif',
          color: '#1A1A1A'
        }} data-id="element-113">
            The Transformation Promise
          </h2>
          <p className="text-sm md:text-base leading-relaxed" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#3D3D3D'
        }} data-id="element-114">
            Our commitment is to your results. This is a digital product for
            immediate impact. All sales are final to ensure we provide the
            lowest possible price for this life-changing information.
          </p>
        </div>
      </section>

      {/* ━━━ FINAL CTA ━━━ */}
      <section className="w-full px-4 py-10 md:py-16 text-center" style={{
      backgroundColor: '#1A1A1A'
    }} data-id="element-115">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{
        color: '#D4A843',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-116">
          Your Body Is Ready to Heal
        </p>
        <h2 className="text-2xl md:text-4xl font-bold mb-4 max-w-xl mx-auto" style={{
        fontFamily: 'Georgia, serif',
        color: '#FDF8F3'
      }} data-id="element-117">
          You Deserve to Feel Like Yourself Again.
        </h2>
        <p className="text-sm md:text-base mb-7 max-w-md mx-auto" style={{
        fontFamily: 'system-ui, -apple-system, sans-serif',
        color: '#9A8A7E'
      }} data-id="element-118">
          Join thousands of moms who stopped fighting their bodies and started
          working with them.
        </p>
        <CTAButton dark data-id="element-119" />
        <p className="text-xs mt-3" style={{
        color: '#555555',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-120">
          One-Time Payment of $14.27 · All Sales Final · Instant Access
        </p>
      </section>

      {/* ━━━ FOOTER ━━━ */}
      <footer className="w-full px-4 py-5 text-center" style={{
      backgroundColor: '#111111',
      borderTop: '1px solid #2A2A2A'
    }} data-id="element-121">
        <p className="text-xs" style={{
        color: '#444444',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-122">
          © 2025 The Cortisol Cure. All rights reserved. · Results may vary.
          This product is not intended to diagnose, treat, cure, or prevent any
          disease.
        </p>
      </footer>

      {/* ━━━ STICKY MOBILE CTA BAR ━━━ */}
      <div className={`fixed bottom-0 left-0 right-0 z-50 px-4 py-3 md:hidden transition-transform duration-300 ${showStickyBar ? 'translate-y-0' : 'translate-y-full'}`} style={{
      backgroundColor: '#1A1A1A',
      borderTop: '1px solid #2A2A2A'
    }} data-id="element-123">
        <a href={PURCHASE_URL} className="block w-full text-center font-bold uppercase rounded-xl py-4 text-sm tracking-wide" style={{
        backgroundColor: '#C85A2A',
        color: '#FFFFFF',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        textDecoration: 'none',
        letterSpacing: '0.03em'
      }} data-id="element-124">
          GET THE CORTISOL CURE — $14.27
        </a>
        <p className="text-center text-xs mt-1.5" style={{
        color: '#555555',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-125">
          One-Time · Instant Access · All Sales Final
        </p>
      </div>
    </div>;
}
/* ━━━ SUB-COMPONENTS ━━━ */
function CTAButton({
  large = false,
  dark = false
}: {
  large?: boolean;
  dark?: boolean;
}) {
  if (large) {
    return <SalesPageButton data-id="element-126" />;
  }
  return <button onClick={() => document.getElementById('offer')?.scrollIntoView({
    behavior: 'smooth'
  })} className="inline-block w-full max-w-lg font-bold uppercase rounded-xl text-center transition-all duration-200 active:scale-95 cursor-pointer px-5 py-4 text-sm" style={{
    backgroundColor: '#C85A2A',
    color: '#FFFFFF',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    boxShadow: '0 4px 20px rgba(200,90,42,0.35)',
    letterSpacing: '0.04em',
    border: 'none'
  }} onMouseEnter={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#A84820';
  }} onMouseLeave={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#C85A2A';
  }} data-id="element-127">
      GET THE CORTISOL CURE — $14.27
    </button>;
}
/** SalesPageButton — scrolls to the pricing section */
function SalesPageButton() {
  const handleScrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <button onClick={handleScrollToOffer} className="inline-block w-full max-w-lg font-bold uppercase rounded-xl text-center transition-all duration-200 active:scale-95 cursor-pointer px-6 py-5 text-sm md:text-base" style={{
    backgroundColor: '#C85A2A',
    color: '#FFFFFF',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    boxShadow: '0 4px 20px rgba(200,90,42,0.35)',
    letterSpacing: '0.04em',
    border: 'none'
  }} onMouseEnter={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#A84820';
  }} onMouseLeave={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#C85A2A';
  }} data-id="element-128">
      GET THE CORTISOL CURE — $14.27
    </button>;
}
/** PurchasePageButton — navigates directly to the Shopify purchase URL */
function PurchasePageButton() {
  const handlePurchase = () => {
    window.fbq('track', 'AddToCart', {
      content_name: 'The Cortisol Cure',
      content_type: 'product',
      value: 14.27,
      currency: 'USD'
    });
    window.location.href = PURCHASE_URL;
  };
  return <button onClick={handlePurchase} className="inline-block w-full max-w-lg font-bold uppercase rounded-xl text-center transition-all duration-200 active:scale-95 cursor-pointer px-6 py-5 text-sm md:text-base" style={{
    backgroundColor: '#C85A2A',
    color: '#FFFFFF',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    boxShadow: '0 4px 20px rgba(200,90,42,0.35)',
    letterSpacing: '0.04em',
    border: 'none'
  }} onMouseEnter={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#A84820';
  }} onMouseLeave={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#C85A2A';
  }} data-id="element-129">
      GET THE CORTISOL CURE — $14.27
    </button>;
}
function ThinDivider() {
  return <div className="w-full max-w-3xl mx-auto px-4" data-id="element-130">
      <div className="h-px w-full" style={{
      backgroundColor: '#E8DDD0'
    }} data-id="element-131" />
    </div>;
}
function PainCard({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-start gap-3 rounded-xl p-4" style={{
    backgroundColor: '#FFFFFF',
    border: '1px solid #E8DDD0'
  }} data-id="element-132">
      <div className="mt-0.5" data-id="element-133">{icon}</div>
      <p className="text-sm md:text-base leading-relaxed" style={{
      fontFamily: 'system-ui, -apple-system, sans-serif',
      color: '#3D3D3D'
    }} data-id="element-134">
        {text}
      </p>
    </div>;
}
function FeaturePill({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex flex-col items-center justify-center gap-1.5 rounded-xl px-2 py-3" style={{
    backgroundColor: '#EDF4F0',
    color: '#4A7C59'
  }} data-id="element-135">
      {icon}
      <span className="text-xs font-semibold text-center leading-tight" style={{
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }} data-id="element-136">
        {text}
      </span>
    </div>;
}
function TestimonialCard({
  quote,
  name,
  detail,
  stars
}: {
  quote: string;
  name: string;
  detail: string;
  stars: number;
}) {
  return <div className="rounded-2xl p-5 md:p-6 flex flex-col" style={{
    backgroundColor: '#FFFFFF',
    border: '1px solid #E8DDD0'
  }} data-id="element-137">
      <div className="flex gap-0.5 mb-3" data-id="element-138">
        {Array.from({
        length: stars
      }).map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-current" style={{
        color: '#D4A843'
      }} data-id="element-139" />)}
      </div>
      <p className="text-sm md:text-base leading-relaxed mb-4 flex-1 italic" style={{
      fontFamily: 'Georgia, serif',
      color: '#2D2D2D'
    }} data-id="element-140">
        "{quote}"
      </p>
      <div className="flex items-center gap-2.5" data-id="element-141">
        <div className="w-8 h-8 rounded-full flex items-center justify-center font-bold text-white text-xs flex-shrink-0" style={{
        backgroundColor: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-142">
          {name.charAt(0)}
        </div>
        <div data-id="element-143">
          <p className="font-bold text-xs" style={{
          color: '#1A1A1A',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }} data-id="element-144">
            {name}
          </p>
          <p className="text-xs" style={{
          color: '#9A8A7E',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }} data-id="element-145">
            {detail}
          </p>
        </div>
      </div>
    </div>;
}
function BundleRow({
  icon,
  label,
  title,
  value
}: {
  icon: React.ReactNode;
  label: string;
  title: string;
  value: string;
}) {
  return <div className="flex items-center gap-3 p-4 md:p-5" data-id="element-146">
      <div className="flex-shrink-0" data-id="element-147">{icon}</div>
      <div className="flex-1 min-w-0" data-id="element-148">
        <p className="text-xs font-bold uppercase tracking-wide mb-0.5" style={{
        color: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-149">
          {label}
        </p>
        <p className="text-sm font-medium leading-snug" style={{
        color: '#1A1A1A',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-150">
          {title}
        </p>
      </div>
      <div className="text-right flex-shrink-0" data-id="element-151">
        <p className="text-xs line-through" style={{
        color: '#9A8A7E',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-152">
          {value}
        </p>
        <p className="text-xs font-bold" style={{
        color: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-153">
          FREE
        </p>
      </div>
    </div>;
}